import React from 'react';

import { Switch, Route } from 'react-router-dom';
import Blogs from './components/Blogs';
import ManageBlog from './components/ManageBlog';

import PageNotFound from './components/PageNotFound';

import Header from './components/Header';
import Blog from './components/Blog';
import About from './components/About';
import Login from './components/Login';
import Signup from './components/Signup';
import ProtectedRoutes from './components/ProtectedRoutes';

const App = () => {
  return (
    <div>
      <Header />
      <Switch>
        {/* <Route exact path='/'>
          <Blogs />
        </Route> */}

        <Route exact path='/' component={Blogs} />

        <Route path='/login' component={Login} />
        <Route path='/signup' component={Signup} />

        <Route path='/manageBlogs/:id' component={ManageBlog} />

        <ProtectedRoutes exact path='/blog/:id' component={Blog} />

        <Route path='/manageBlogs' component={ManageBlog} />

        <Route path='/about'>
          <About />
        </Route>

        <Route component={PageNotFound} />
      </Switch>
    </div>
  );
};

export default App;
